<template>

  <div class="drink-store-edit">
    <div class="drink-store-edit-operate">
      <p class="drink-store-edit-operate-title clear-fix">
        <span>{{$t('tong_bu_yin_ping_pei_fang')}}</span>
        <el-button class="error delete-drink-store float-right" type="text" size="mini" @click="handleDeleteDrinkSync">
          <i
            class="iconfont icon-shanchu"></i> {{$t('shan_chu_pei_fang')}}
        </el-button>
      </p>
      <div class="drink-store-edit-content">
        <div class="drink-store-edit-item">
          <p class="drink-store-edit-item-title">
            {{$t('yin_pin_xin_xi')}}
          </p>
          <div>
            <el-table :data="drinks" size="mini" height="240" maxHeight="240" border>
              <el-table-column :label="$t('yin_pin_bian_hao')" align="center" min-width="120px">
                <template slot-scope="scope">
                  <span>{{scope.row.drinkUuid}}</span>
                </template>
              </el-table-column>
              <el-table-column :label="$t('yin_pin_ming_cheng')" align="center">
                <template slot-scope="scope">
                  <span>{{scope.row.name}}</span>
                </template>
              </el-table-column>
              <el-table-column :label="$t('yin_pin_ying_wen_ming_cheng')" align="center">
                <template slot-scope="scope">
                  <span>{{scope.row.engName}}</span>
                </template>
              </el-table-column>
              <el-table-column :label="$t('cao_zuo')" align="center">
                <template slot-scope="scope">
                  <span class="delete" v-show="drinks.length >1" @click="handleRemoveDrink(scope.$index)"><i
                    class="iconfont icon-shanchu"></i>{{$t('yi_chu')}}</span>
                </template>
              </el-table-column>
            </el-table>
          </div>

        </div>

        <div class="drink-store-edit-item">
          <p class="drink-store-edit-item-title">
            {{$t('she_bei_xin_xi')}}<span @click="handleDeviceShow"><i class="iconfont icon-tianjia"></i>{{$t('xin_zeng_tong_bu_she_bei')}}</span>
          </p>
          <div class="drink-store-edit-item-content drink-height">
            <el-tag
              size="mini"
              v-for="tag in devices"
              :key="tag.deviceUuid"
              @close="handleClose(tag)"
              closable>
              {{tag.deviceName}}
            </el-tag>
          </div>
        </div>

        <div style="text-align: center">
          <el-button type="primary" size="small" @click="handlePushDevice">{{$t('ti_jiao')}}</el-button>
          <el-button @click="goBack" size="small">{{$t('fan_hui')}}</el-button>
        </div>
      </div>

    </div>

    <c-dialog :visible.sync="bindVisible" :width="'42rem'" :height="'36rem'">
      <div slot="title" class="pay-bind-wx-title">
        <p class="pay-bind-wx-title-text">{{$t('zai_xian_she_bei_lie_biao')}}</p>
        <div class="pay-bind-wx-title-container">
          <el-button size="mini" type="primary" @click="handleAddDevice">{{$t('guan_lian_she_bei')}}</el-button>
        </div>

        <div class="pay-bind-wx-title-filter">
          <p>{{$t('tiao_jian_sou_suo')}}:</p>
          <el-input v-model="searchDeviceName" :placeholder="$t('qing_shu_ru_she_bei_ming_chen')" @change="inputChange" size="mini"/>
        </div>

      </div>

      <devices ref="devices"></devices>
    </c-dialog>

    <div class="drink-store-edit-info">
      <p class="drink-store-edit-operate-title">{{$t('tong_bu_cao_zuo_shuo_ming')}}</p>
      <ol class="drink-store-edit-info-content">
        <li class="alarm">{{$t('qing_que_bao_xuan_qu_she_bei_zai_xian')}}</li>
        <li class="alarm">{{$t('xiu_gai_yin_pin_ke_tong_guo_pi_liang_ding_jia_chu_jin_xing_xiu_gai')}}</li>
        <li class="alarm">{{$t('she_bei_lie_biao_zhong_de_yin_pin_xin_xi_ke_jin_xing_dan_ge_yin_pin_xin_xi_xiu_gai')}}</li>
        <li>{{$t('yi_chu_pei_fang_zhong_yin_pin_xin_xi_bu_hui_ying_xiang_yuan_shi_pei_fang_shu_ju')}}</li>
        <li>{{$t('pei_fang_yin_pin_bu_yun_xu_xin_zeng')}}</li>
        <li>{{$t('xuan_qu_xu_yao_tong_bu_she_bei_hou')}}</li>
      </ol>
    </div>

    <loading :show="showLoading" :text="$t('she_bei_yin_pin_tui_song_zhong')"/>
  </div>
</template>

<script>

  import {drinkSyncDelete, drinkSyncProductUuid, drinkSyncPushDevice} from '@/api/delivery/device/drink'
  import CDialog from '@/components/Dialog'
  import Devices from './device_online'
  import Loading from '@/components/Loading'

  export default {
    name: '',
    components: {
      CDialog,
      Devices,
      Loading
    },
    activated: function () {
      this.showLoading = false
      this.uuid = this.$route.params.uuid || ''
      if (!this.uuid) {
        this.$router.back()
        return;
      }

      this.productUuid = this.$route.params.productUuid || ''
      if (!this.productUuid) {
        drinkSyncProductUuid({uuid: this.uuid}).then(res => {
          this.productUuid = res.data
        })
      }

      this.drinks = this.$route.params.drink
    },
    data: function () {
      return {
        uuid: '',
        productUuid: '',
        devices: [],
        drinks: [],
        searchDeviceName: '',
        bindVisible: false,
        showLoading: false,
      }
    },
    methods: {
      goBack() {
        this.$router.back()
      },
      handleDeviceShow() {
        this.bindVisible = true
        let devices = []
        this.devices.forEach(item => {
          devices.push(item)
        })
        this.$nextTick(function () {
          this.$refs.devices.loadDevices(this.productUuid, this.searchDeviceName, devices)
        })
      },

      inputChange(val) {
        this.$refs.devices.loadDevices(this.productUuid, val)
      },

      handlePushDevice() {
        if (this.devices.length === 0) {
          this.$message.warning(this.$t('qing_xuan_qu_xu_yao_tui_song_de_she_bei'))
          return
        }
        let deviceUuid = []
        this.devices.forEach(item => {
          deviceUuid.push(item.deviceUuid)
        })
        let vue = this
        drinkSyncPushDevice({uuid: this.uuid, deviceUuid: deviceUuid, param: this.drinks}).then(res => {
          vue.showLoading = true
          setTimeout(function () {
            vue.showLoading = false
            vue.$message.success(this.$t('yin_pin_xin_xi_yi_xia_fa'))
          }, 2000 * deviceUuid.length)
        })
      },
      handleDeleteDrinkSync() {
        this.$confirm(this.$t('ci_cao_zuo_jiang_shan_chu_yin_pin_pei_fang'), this.$t('ti_shi'), {
          confirmButtonText: this.$t('que_ding'),
          cancelButtonText: this.$t('qu_xiao'),
          type: 'warning'
        }).then(() => {
          let vue = this
          drinkSyncDelete({uuid: vue.uuid}).then(res => {
            vue.$message.success(this.$t('shan_chu_cheng_gong'))
            vue.goBack()
          })


        }).catch(() => {

        })
      },
      handleRemoveDrink(index) {
        this.drinks.splice(index, 1)
      },
      handleClose(tag) {
        this.devices.splice(this.devices.indexOf(tag), 1);
      },
      handleAddDevice() {
        this.devices = this.$refs.devices.getDevices() || []
        this.bindVisible = false
      },
    },
  }
</script>

<style lang="scss">
  .drink-store-edit {
    display: flex;

    .drink-store-edit-operate-title {
      font-weight: 500;
      line-height: 1.7;
    }

    .drink-store-edit-operate {
      flex: 1;
      padding: $padding;
      display: flex;
      flex-direction: column;

      .drink-store-edit-operate-content {
        flex: 1;
        display: -webkit-box;
        -webkit-box-orient: horizontal;
        -webkit-box-pack: center;
        -webkit-box-align: start;

        display: -moz-box;
        -moz-box-orient: horizontal;
        -moz-box-pack: center;
        -moz-box-align: center;
      }
    }

    .drink-store-edit-info {
      width: 24%;
      background-color: #30363eba;
      border-radius: 4px;
      padding: $padding;
    }

    .drink-store-edit-info-content {
      font-size: 12px;

      list-style-type: none;
      counter-reset: sectioncounter;

      li:before {
        content: counter(sectioncounter) "、";
        counter-increment: sectioncounter;
      }

      li {
        line-height: 1.5;
      }
    }

    .drink-store-edit-content {

      .el-input-number__increase, .el-input-number__decrease {
        border-color: #D8DDE3;
      }
    }

    .float-right {
      float: right;
    }

    .alarm {
      color: $btn_color;
    }

    .error {
      color: $btn_sec_color !important;
    }

    .delete {
      cursor: pointer;
      color: $btn_sec_color;
    }

    .el-tag + .el-tag {
      margin-left: 10px;
    }

    .drink-store-edit-item {
      margin-bottom: $padding;


      .drink-store-edit-item-title {
        margin-bottom: $padding;
        font-size: 14px;

        span {
          float: right;
          font-size: 12px;
          display: inline-block;
          cursor: pointer;

          i {
            font-size: 14px;
          }
        }
      }

      .el-table--border {
        border-bottom: 1px solid #ffffff;
      }

      .el-table__row > td {
        border-top: 1px solid #ffffff;
        border-bottom: 1px solid #ffffff;
      }

      .drink-store-edit-item-content {
        background-color: #30363eba;
        border-radius: 4px;
        padding: $padding;
      }

      .drink-height {
        height: 180px;
        overflow-y: scroll;
      }
    }

    .delete-drink-store {

      i {
        font-size: 14px;
      }
    }

    .pay-bind-wx-title {
      display: flex;
      padding: $padding 0;
      align-content: center;

      &-text {
        font-weight: 500;
        margin-right: $padding;
      }

      &-container {
        flex: 1;
        text-align: left;
      }

      &-filter {
        //flex: 1;
        display: flex;
        text-align: right;
        align-content: center;
        margin-right: $padding;

        p {
          width: 120px;
          font-size: 12px;
          margin-right: $padding;
          text-align: right;
        }
      }
    }
  }


  body.dark {
    .drink-store-edit-content {
      .el-input-number__increase, .el-input-number__decrease {
        border-color: #889DB8;
      }
    }

    .delete-drink-store {
    }
  }
</style>
